import { render, staticRenderFns } from "./cms-block-columns.vue?vue&type=template&id=c563182c&scoped=true"
import script from "./cms-block-columns.vue?vue&type=script&lang=js"
export * from "./cms-block-columns.vue?vue&type=script&lang=js"
import style0 from "./cms-block-columns.vue?vue&type=style&index=0&id=c563182c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c563182c",
  null
  
)

export default component.exports